import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Col, Row,
} from 'react-bootstrap';
import {
  VVGModal,
  trEnv,
  Headline,
  FormRadio,
  FormMask,
  If,
  FormCombobox,
  FormDatePicker,
  appActions,
  ErsteDatenVersBeginnFormDatepicker,
  SubHeadline,
  SummingUp,
  SummingUpKundendaten,
  SpeicherButton,
  PrevNextButton,
  useNextPage,
  useUpdateAndValidateOnChange,
  useUpdateByNameAndValidateOnChange,
  useUpdateAndValidateDateOnChange,
  EnumVorgangsart,
  istEnumAuswahl,
  AdresseForm, FormWrapper,
} from 'ion-lib';
import i18next from 'i18next';
import { trackByName } from '../../tracking';
import { getBannerFileName, istHausrat, setBeratersuche } from '../../helper';
import NeuordnungModal from '../../components/NeuordnungModal';
import { EnumNeuordnung } from '../../components/enum';
import ZuersPruefung from '../../components/ZuersPruefung';

const ErsteDaten = ({
  container,
}) => {
  const validateDateOnChange = useUpdateAndValidateDateOnChange();
  const validateOnChangeByName = useUpdateByNameAndValidateOnChange();
  const validateOnChange = useUpdateAndValidateOnChange();
  const nextPage = useNextPage();

  const dispatch = useDispatch();

  const wagnis = useSelector((state) => state.daten.wagnis);
  const tarifart = useSelector((state) => state.daten.tarifart);
  const geburtsdatum = useSelector((state) => state.daten.vn.geburtsdatum);
  const frageHabenSieBereitsHausrat = useSelector((state) => state.daten.frageHabenSieBereitsHausrat);
  const frageBestehendenVertragAnpassen = useSelector((state) => state.daten.frageBestehendenVertragAnpassen);
  const vsnrHausratAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratAltFuerNeuordnung);
  const vsnrHausratGlasAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratGlasAltFuerNeuordnung);
  const vorgangsart = useSelector((state) => state.daten.vorgangsart);
  const auswahlNeuordnung = useSelector((state) => state.daten.auswahlNeuordnung);

  useEffect(() => {
    if (trEnv.sparkasse && wagnis.plz.value !== '' && geburtsdatum.value !== '') {
      dispatch(appActions.serverValidationRequest('validiere', [
        'wagnis.plz',
        'wagnis.ort',
        'vn.geburtsdatum',
      ]));
    }
  }, []);

  const handleNextClick = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'wagnis.strasse',
      'wagnis.hnr',
      'wagnis.plz',
      'wagnis.ort',
      'wagnis.wohnflaeche',
      'wagnis.typ',
      'tarifart',
      'vn.geburtsdatum',
      'versBeginn',
      'frageHabenSieBereitsHausrat',
      'frageBestehendenVertragAnpassen',
      'vsnrHausratAltFuerNeuordnung',
    ], () => {
      dispatch(appActions.serverValidationRequest('berechne', [], () => {
        nextPage();
      }));
    }));
  };

  const handleDatePicker = (name, value) => {
    trackByName(name, value);
    validateOnChangeByName(name, value);
  };

  const getUKZ = () => {
    switch (true) {
      case trEnv.istOESA:
        return '0301-***.***.***';
      case trEnv.istOEVO:
        return '0501-***.***.***';
      case trEnv.istOEVB:
        return '0601-***.***.***';
      default:
        return '0101-***.***.***';
    }
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel">
          <Headline>{i18next.t('erstedaten.headline')}</Headline>
          <SubHeadline>{i18next.t('erstedaten.berechnenSieInWenigenSekunden')}</SubHeadline>
          <If predicate={frageHabenSieBereitsHausrat.relevant && !trEnv.stationaer}>
            <FormRadio
              {...frageHabenSieBereitsHausrat}
              title={i18next.t('erstedaten.frageHabenSieBereitsHausrat')}
              name="daten.frageHabenSieBereitsHausrat.value"
              onChange={validateOnChange}
              className="mb-5"
            />
          </If>
          <If predicate={frageBestehendenVertragAnpassen.relevant && !trEnv.stationaer}>
            <FormRadio
              {...frageBestehendenVertragAnpassen}
              title={i18next.t('erstedaten.frageBestehendenVertragAnpassen')}
              name="daten.frageBestehendenVertragAnpassen.value"
              onChange={validateOnChange}
              className="mb-5"
            />
          </If>
          <If predicate={vsnrHausratAltFuerNeuordnung.relevant && !trEnv.stationaer}>
            <FormMask
              {...vsnrHausratAltFuerNeuordnung}
              title={i18next.t('erstedaten.vsnrHausratAltFuerNeuordnung')}
              name="daten.vsnrHausratAltFuerNeuordnung.value"
              onChange={validateOnChange}
              inputmask={{
                mask: getUKZ(),
              }}
              className="mb-5"
            />
          </If>
          <FormWrapper
            label="Wie lautet Ihre Anschrift?"
            overlay="Hier finden Sie Hilfe"
            tooltip={() => dispatch(appActions.toggleModal(i18next.t('erstedaten.anschrift_tt')))}
            subtitle={i18next.t('erstedaten.anschrift_sub')}
            name="anschrift"
          />
          <AdresseForm
            postleitzahl={wagnis.plz}
            postleitzahlName="daten.wagnis.plz.value"
            ort={wagnis.ort}
            ortName="daten.wagnis.ort.value"
            strasse={wagnis.strasse}
            strasseName="daten.wagnis.strasse.value"
            hausnummer={wagnis.hnr}
            hausnummerName="daten.wagnis.hnr.value"
          />

          <ZuersPruefung />

          <FormMask
            {...wagnis.wohnflaeche}
            title="Wie groß ist die Wohnfläche?"
            name="daten.wagnis.wohnflaeche.value"
            tooltip={() => dispatch(appActions.toggleModal(i18next.t('erstedaten.wohnflaeche_tt')))}
            onChange={validateOnChange}
            inputmask={{
              mask: '999',
              maskChar: '',
            }}
            inputMode="numeric"
            inputClassName="text-center"
            className="my-5"
            inputGroup="m²"
          />

          <If predicate={wagnis.typ.relevant}>
            <FormRadio
              {...wagnis.typ}
              title="Was möchten Sie versichern?"
              name="daten.wagnis.typ.value"
              onChange={validateOnChange}
              tooltip={() => dispatch(appActions.toggleModal(setBeratersuche('erstedaten.typ_tt', wagnis)))}
            />
          </If>
          <div className="mb-5" dangerouslySetInnerHTML={{ __html: setBeratersuche('erstedaten.versicherbar', wagnis) }} />

          <FormDatePicker
            {...geburtsdatum}
            className="mb-5"
            title="Wann wurden Sie geboren?"
            name="daten.vn.geburtsdatum.value"
            onInputChange={validateDateOnChange}
            onChange={handleDatePicker}
            from={100}
            to={-18}
            tooltip={istHausrat() ? () => dispatch(appActions.toggleModal(i18next.t('erstedaten.gebdat_tt'))) : null}
            message={geburtsdatum.warning && `<p>${geburtsdatum.warning}</p>`}
            showFormatHint
          />

          <If predicate={tarifart.relevant && !trEnv.stationaer}>
            <FormRadio
              {...tarifart}
              title={i18next.t('erstedaten.tarifart')}
              name="daten.tarifart.value"
              onChange={validateOnChange}
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('erstedaten.oeffdienst_tt')))}
              className="mb-5"
            />
          </If>

          <If predicate={tarifart.relevant && trEnv.stationaer}>
            <FormCombobox
              {...tarifart}
              title={i18next.t('erstedaten.tarifart')}
              name="daten.tarifart.value"
              onChange={validateOnChangeByName}
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('erstedaten.oeffdienst_tt')))}
              className="mb-5"
            />
          </If>

          <ErsteDatenVersBeginnFormDatepicker
            onChange={handleDatePicker}
            position="top"
            minDate={new Date()}
            onInputChange={validateDateOnChange}
            tooltip={() => dispatch(appActions.toggleModal(i18next.t('erstedaten.versbeginn_tt')))}
          />

          <VVGModal />
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              nextProps={{
                text: i18next.t('erstedaten.weiter'),
                className: 'btn-xs-block btn--animate',
              }}
              onNextClick={handleNextClick}
            />
            <SpeicherButton />
          </Col>
        </Row>
      </Col>
      <SummingUp bannerImg={getBannerFileName}>
        <If predicate={!istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG)}>
          <SummingUpKundendaten title="Ihre Daten" />
          <NeuordnungModal getUKZ={getUKZ} container={container} />
        </If>
        <If predicate={istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG)}>
          {/* Neuordnung Hausrat */}
          <If predicate={istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.KOMBI) || istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.HAUSRAT) || trEnv.ifiliale}>
            <h4 className="text-center">
              Neuordnung zu VSNR
              {' '}
              {vsnrHausratAltFuerNeuordnung.value}
            </h4>
          </If>

          {/* Neuordnung Hausrat und Glas */}
          <If predicate={istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.KOMBI) || istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.GLAS)}>
            <h4 className="text-center">
              Neuordnung zu VSNR
              {' '}
              {vsnrHausratGlasAltFuerNeuordnung.value}
            </h4>
          </If>
          <NeuordnungModal getUKZ={getUKZ} container={container} />
        </If>

      </SummingUp>
    </Row>
  );
};

export default ErsteDaten;
